const { Core } = Global;


customElements.define('sweeps-entries-bar', class extends Core {
    propTypes = {
        'cart-amount': Number,
        'progress-text': String,
        'complete-text': String
    }

    elements = {
        $: [
            'message',
            'fill',
            ['nodes'],
            ['label-amounts']
        ],
    }

    render() {
        this.rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
        this.total = this.prop('cart-amount');
        this.tiers = (this.$('nodes') || []).map(node => ({
            node,
            amount: Number(node.dataset.amount) * this.rate,
            entries: Number(node.dataset.entries) || 0
        }));

        if(!this.tiers.length) {
            return;
        }

        this._renderLabels();
        this._renderProgress();
        this._renderMessage();
    }

    _renderLabels() {
        (this.$('label-amounts') || []).forEach($label => {
            $label.innerText = this._money(Number($label.dataset.amount) * this.rate);
        });
    }

    _renderProgress() {
        const max = Math.max(...this.tiers.map(tier => tier.amount));
        const progress = max > 0 ? Math.min(this.total * 100 / max, 100) : 0;

        this.$('fill').style.setProperty('--progress', progress);
        this.tiers.forEach(tier => tier.node.classList.toggle('@reached', this.total >= tier.amount));
    }

    _renderMessage() {
        const next = this.tiers
            .filter(tier => this.total < tier.amount)
            .sort((a, b) => a.amount - b.amount)[0];

        this.$('message').innerHTML = next
            ? this._interpolate(this.prop('progress-text'), {
                amount: this._money(next.amount - this.total),
                entries: next.entries
            })
            : this._interpolate(this.prop('complete-text'), {
                entries: this.tiers.reduce((sum, tier) => sum + tier.entries, 0)
            });
    }

    _interpolate(template, values) {
        return this._escape(template || '').replace(
            /\{(\w+)\}/g,
            (match, key) => key in values ? `<b class="ss-eb-hl">${values[key]}</b>` : match
        );
    }

    _escape(str) {
        const $el = document.createElement('div');
        $el.innerText = str;
        return $el.innerHTML;
    }

    _money(cents) {
        cents = Math.round(cents);

        const format = cents % 100 === 0
            ? Shopify.money_format.replace(/amount(?!_)/, 'amount_no_decimals')
            : Shopify.money_format;

        return Shopify.formatMoney(cents, format);
    }
})
